import { render, staticRenderFns } from "./StudentLessonAbsences.vue?vue&type=template&id=33af1cb1"
import script from "./StudentLessonAbsences.vue?vue&type=script&lang=js"
export * from "./StudentLessonAbsences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports